export const ENDPOINT_AUTH = 'authenticate'
export const ENDPOINT_USERDATA = 'account'
export const ENDPOINT_EMAILRESET = 'account/reset-password/init'
export const ENDPOINT_FINISHRESETPASSWORD = 'account/reset-password/finish'
export const ENDPOINT_USER_AUTHORITIES = 'users/authorities'
export const ENDPOINT_CREATE_USER = 'users'
export const ENDPOINT_CUSTOMER_ORDER = '_search/supply-orders'
export const ENDPOINT_CUSTOMER_ORDER_CHANGES_ACTIONS = 'supply-orders/actions'
export const ENDPOINT_ORDERS_CHANGES_ACTIONS = 'supply-orders/effective-status'
export const ENDPOINT_AVAILABLE_ORDER = '_search/supply-orders-available'
export const ENDPOINT_DISPATCH_ORDER = '_search/supply-orders-dispatched'
export const ORDERS_SET_STATE_INPREPARATION = 'supply-orders/in-preparation'
export const ORDERS_EFFECTIVE_STATUS = 'effective-status/dispatched-orders'
export const DOWNLOAD_CSV = 'download/customer-orders-csv'
export const DOWNLOAD_LABELS = 'generate-label/download'
export const DHL_LABELS = 'dhl-labels'
export const DHL_DOWNLOAD = 'download'
export const ITEMS = 'supply-order-items'
export const SUPPLIERS = 'suppliers/authorized'
export const SUPPLIER_REJECT_REASONS = 'reject-reasons'
export const SUPPLIER_EFFECTIVE_STATUS_FILTER = '_search/effective-status/filter'
export const INCIDENT_REASSONS = 'reason-reference-data/'
export const ENDPOINT_CARRIER_DISPATCH_ORDER = 'carrier/dispatch-order'



// WEBPACK FOOTER //
// ./src/repository/endpoints.js